export function PageTopbar({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full py-4 pr-[63px] pl-[41px] items-center gap-4 border-b-[1px] border-solid border-neutral-200 min-h-[75px] box-border">
      {children}
    </div>
  );
}
